export default __webpack_public_path__ + "static/media/bites-logo-text.614d9f1c.png";